export const LANGUAGES_OPTIONS = [
  { label: "English", value: "en" },
  { label: "Spanish", value: "es" },
];
